export default __webpack_public_path__ + "images/86e011b1110c860bd7388e41093110b0-menu-dog-treat.svg";